import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AdminDashboardMetricDto } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useInternalDashboardMetrics = (): UseQueryResult<AdminDashboardMetricDto> =>
  useQuery(
    cacheKeysUtil.internalDashboardMetrics(),
    async (): Promise<AdminDashboardMetricDto> => (await tFinancialService.api.getAdminDashboardMetrics()).data.data
  );
